import db from "../Db";

export function GetAllConcessEtatEcheance() {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.CONCESS_ETAT_ECHEANCE.toArray().then((result) => {
      return resolve(result);
    });
  });
}
